/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 15:20 27.04.2023
 * @ Description: Page qui permette d'amdministrer le site web
 */


import React, { useEffect, useRef, useState } from 'react';
import "./index.css";
import { Link } from "react-router-dom";
import api from '../../utils/api';


function SentenceAnswerConfig(props){
  const sentence=useRef(props.sentence)

  const [sentenceWords,setSentenceWords]=useState(null);

  const [isSave,setIsSave]=useState(true);
  const [copyBntName,setCopyBntName]=useState("Copy Text");


  function onSave(){
    api.updateSentenceError(sentence.current.id,getNewErrors(sentence.current));
    navigator.clipboard.writeText(JSON.stringify(api.SentenceObjectToJson(props.sentence,getNewErrors(sentence.current)))+",");
    setIsSave(true);
  }

  function getNewErrors(sentence){
    let errors=[];
    for (let index = 0; index < sentence.actualAnswerWord.length; index++) {
      const element = sentence.actualAnswerWord[index];
      let jsonErrorObject={
        startPos: element.startPos, 
        endPos: element.endPos, 
        replace: "", 
        fkSentence: sentence.id
      }
      errors.push(jsonErrorObject);
    }
    return errors;
  }

  useEffect(()=>{
    let worldButtons=sentence.current.generateWordButtonsAdmin(()=>{
      setIsSave(false);
    });
    setSentenceWords(worldButtons);
  },[])

  return (
    <div className='SentenceAnswerConfig'>
      <button className='CopyBnt' onMouseOver={()=>setCopyBntName("Copy Text")} onClick={()=>{
          navigator.clipboard.writeText(sentence.current.sentence);
          setCopyBntName("Copied");
      }}>{copyBntName}</button>
      <button disabled={isSave} onClick={onSave}>Save</button>
      <div className='sentence'>{sentenceWords}</div>
    </div>
  );
}



export default function AdminPage() {
  const [sentencesAnswerContent,setSentencesAnswerContent]=useState(null);

  useEffect(()=>{
    api.getAllSentence((data)=>{
        let content=[];
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            content.push(<SentenceAnswerConfig sentence={element}/>);
        }
        setSentencesAnswerContent(content);
    })
  },[])

  return (
    <div className='AdminPage'>
      <h1>Admin page :)</h1>
        <div className='Section'>
          <h2>Sentence anwser</h2>
          {sentencesAnswerContent}
        </div>
    </div>
  );
}